import ProductsReport from "./ProductsReport";

export default ProductsReport;
